import { AgreementGroupTipTypeEnum } from '../../models/cartDetails/agreementGroupTipType.model';
import { AgreementsStorageService } from './agreements-storage.service';
import { AgreementStorageDataModel } from './agreement-storage-data.model';
import { AgreementItemModel } from './agreement-item.model';
import { AgreementBasicModel } from './agreement-basic.model';
import { IAgreement, IAgreementSet } from '../../interfaces/agreements.interface';

export class AgreementGroupModel extends AgreementBasicModel {
  public id: number;
  public title: any;
  public tipType: string;
  public tipMessage: string;
  public srOnlyText: string;
  public playAgreements: Array<AgreementItemModel> = [];
  public isTipInfo: boolean;
  public required = false;
  public touched = false;
  public groupStorage: AgreementStorageDataModel;
  protected parentStorage: AgreementStorageDataModel;

  constructor(
    agreementGroup: IAgreementSet,
    storage: AgreementsStorageService,
    parentStorage: AgreementStorageDataModel
  ) {
    super(storage);

    this.id = Number(agreementGroup.id);
    this.name = agreementGroup.name;
    this.selected = agreementGroup.selected || false;
    this.expanded = agreementGroup.expanded;
    this.priority = agreementGroup.priority;
    this.tipType = agreementGroup.tipType;
    this.isTipInfo = this.tipType === AgreementGroupTipTypeEnum.INFO;
    this.tipMessage = agreementGroup.tipMessage;
    this.parentStorage = parentStorage;

    this.groupStorage = this.storage.createGroupStorage(this.id, parentStorage);

    this.addAgreementsToGroup(agreementGroup.playAgreements, this.id);
    this.prepareTitle(agreementGroup);
  }

  private prepareTitle(agreementGroup: IAgreementSet): void {
    const title = agreementGroup.title;
    this.title = title;

    if (this.required) {
      this.title = `${title}&nbsp;<span class="required-mark">*</span>`;
    }
  }


  private addAgreementsToGroup(
    agreements: IAgreement[],
    groupId: number
  ): void {
    this.clearAgreements();

    agreements.forEach((agreement: IAgreement, agreementIndex: number) => {
      const agreementItem: AgreementItemModel = new AgreementItemModel(agreement, groupId, this.storage, agreementIndex);

      this.playAgreements.push(agreementItem);
      this.storage.addAgreement(agreementItem);
    });

    this.required = this.playAgreements.some(agreement => agreement.required);
  }

  private clearAgreements() {
    this.playAgreements = [];
  }
}
